import { render, staticRenderFns } from "./fccSituacaoSir.vue?vue&type=template&id=b96259c0"
import script from "./fccSituacaoSir.vue?vue&type=script&lang=js"
export * from "./fccSituacaoSir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports